import { Accordion, DropdownItem, Separator } from '@mc/design-system'
import Nav from '@mc/navigation'
import classes from './AccordionMenu.module.scss'

type ProductType = 'consumer' | 'enterprise' | 'certificates' | 'onCall'

export type ProductLink = {
  title: string
  href?: string
  onClick?: () => void
}

export type Product = {
  type: ProductType
  title: string
  links: ProductLink[]
  callout?: React.ReactNode
  separator?: boolean
  onClick?: () => void
}

export const AccordionMenu = ({
  products,
  defaultExpandedProduct,
  productSectionClassName,
}: {
  products: Product[]
  defaultExpandedProduct?: ProductType
  productSectionClassName?: string
}) => (
  <Accordion
    className='c-px-4'
    preExpanded={
      defaultExpandedProduct !== undefined
        ? [`item-${defaultExpandedProduct}`]
        : []
    }
  >
    {products.map((product) => (
      <Accordion.Item
        key={product.title}
        uuid={`item-${product.type}`}
        className='mc-bg-transparent mc-bg-hover-transparent'
        label={<h3>{product.title}</h3>}
        onClick={product.onClick}
      >
        <div className={`mc-corners--md ${productSectionClassName}`}>
          {product.links.map((link) =>
            !link.href ? (
              <DropdownItem
                className='c-p-4'
                key={link.title}
                onClick={(e) => {
                  e.stopPropagation()
                  link.onClick?.()
                }}
              >
                {link.title}
              </DropdownItem>
            ) : (
              <Nav.MenuLink
                key={link.title}
                href={link.href}
                onClick={(e) => {
                  e.stopPropagation()
                  link.onClick?.()
                }}
              >
                {link.title}
              </Nav.MenuLink>
            ),
          )}
          {product.separator && (
            <Separator className={`c-m-4 ${classes.separator}`} />
          )}
          {product.callout}
        </div>
      </Accordion.Item>
    ))}
  </Accordion>
)
